import orderBy from 'lodash/orderBy';
import type { Ref } from 'vue';
import { computed } from 'vue';
import type { LeagueSize, SportType } from '@/interface/enum';
import { useMarkets } from '@/libraries/oddsApi/composables/useMarkets';

export function useMatchMarkets(
    matchId: number,
    isLive: Ref<boolean>,
    sportType: SportType,
    leagueSize: LeagueSize,
    leagueId: number,
    isEnabled: Ref<boolean>,
) {
    const { markets, loaded, loading, refetch } = useMarkets(matchId, isLive, sportType, leagueSize, leagueId, isEnabled);

    const sortedMarkets = computed(() => {
        const sortedMarketsSelections = markets.value.map(market => ({
            ...market,
            selections: orderBy(market.selections, [selection => selection.selectionOrder, selection => selection.id]),
        }));

        return orderBy(sortedMarketsSelections, [market => market.displayPriority, market => market.id]);
    });

    return {
        sortedMarkets,
        loaded,
        loading,
        refetch,
    };
}
